//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Nav from "@/components/Nav";
export default {
  name: "popdetais",
  components: {
    Nav
  },
  data() {
    return {
      details: ""
    };
  },
  methods: {
    goback() {
      if (window.location.search.includes('from=')) {
        window.location.href = '/'
      }else{
        this.$router.back();
      }
    }
  },
  created() {
    let _this = this;
    let id = this.$route.query.id;
    // console.log(this.$route.params.id);
    this.$api.Articledetails(id).then(res => {
      // console.log(22, res);
      _this.details = res.data.data;
      // console.log(_this.details);
      document.title= _this.details.title
    });
  },
  watch: {
    $route: function(to, from) {
      let _this = this;
      // console.log(11, to.query.id);
      if (to.query.id != undefined) {
        this.$api.Articledetails(to.query.id).then(res => {
          // console.log(1111, res.data.data);
          _this.details = res.data.data;
          // console.log(_this.details);
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/Popularactivities/popdetais.vue